import { Directive, TemplateRef, Input, ViewContainerRef } from '@angular/core';
import { StateLifeCycle } from '../../Models/enum/stateLifeCycle';

@Directive({
  selector: '[appShowByRequiredPermission]'
})
export class ShowByRequiredPermissionDirective {

  stateExpressionPattern = new RegExp(/(\S+)\s+(state)\s*\:\s*([^\s]+)\s+when\s+([^\s]+)/);
  _userStatePermissions = {};
  _expression: string;
  _state: any;
  overridableStateLifeCycles = [
    StateLifeCycle.waitingForHumanInteraction,
    StateLifeCycle.waitingForResponse,
    StateLifeCycle.finished,
    StateLifeCycle.error
  ];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {  }

  @Input()
  set appShowByRequiredPermission(expression: any) {
    this._expression = expression;
  }

  @Input()
  set appShowByRequiredPermissionState(state: any) {
    this._state = state;
  }

  @Input()
  set appShowByRequiredPermissionStatePermissions(permissions: any[]) {
    this._userStatePermissions = permissions;
    const requiredPermission = this.parsePermissionExpression(this._expression);
    if (this.checkPermission(requiredPermission.action, requiredPermission.securableObject, requiredPermission.lifeCycle)) {
      if (this.viewContainerRef['_embeddedViews'].length < 1) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainerRef.clear();
    }
  }

  parsePermissionExpression(expression) {
    const res = {
      action: '',
      objectType: null,
      securableObject: null,
      lifeCycle: null
    };

    if (this.stateExpressionPattern.test(expression)) {
      res.action = RegExp.$1;
      res.objectType = RegExp.$2;
      res.securableObject = RegExp.$3;
      res.lifeCycle = RegExp.$4;
    }
    return res;
  }

  checkPermission(action, securableObject, lifeCycle) {
    let hasPermission = false,
      allowedStates;

    if (action.toLowerCase() !== 'trace') {
      if (!action || !securableObject || !lifeCycle) {
        return false;
      }
    } else {
      if (!action || !securableObject) {
        return false;
      }
    }

    switch (action.toLowerCase()) {
      case 'cancel':
        allowedStates = this._userStatePermissions['Cancelar'] || [];
        hasPermission = (Number(lifeCycle) !== 13) && allowedStates.includes(Number(securableObject));
        break;

      case 'override':
        allowedStates = this._userStatePermissions['Impor'] || [];
        hasPermission = this.overridableStateLifeCycles.includes(Number(lifeCycle))
          && this._state.preDefinedOverrideStateId
          && allowedStates.includes(Number(securableObject))
          && allowedStates.includes(Number(this._state.preDefinedOverrideStateId));
        break;

      case 'view':
        allowedStates = this._userStatePermissions['VisualizarInstância'] || [];
        hasPermission = allowedStates.includes(Number(securableObject));
        break;
    }
    return hasPermission;
  }

}
